import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, Row, Col } from 'antd';
import 'antd/dist/antd.css';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import styles from './Legend.module.scss';
import lagescoresColorsIntensity from '../../../../utils/lagescores-colors';
import legendText from '../../../../utils/legendText';
import useWindowDimensions from '../../../../utils/hooks/useWindowDimensions';
import { ISPRINTMAPALLOWED } from '../../../../utils/constants';
import { TestID } from 'utils/testId';

const Legend = ({ selectedOption }) => {
  const { height, width } = useWindowDimensions();
  const [show, setShow] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [text, setText] = useState();
  const [colorValues, setColorValues] = useState();

  const selectColorRangeAndText = (option) => {
    setText(legendText[option]);
    setColorValues(lagescoresColorsIntensity[option]);
  };

  useEffect(() => {
    selectColorRangeAndText(selectedOption);
  }, [selectedOption]);

  return (
    <>
      <div>
        {colorValues && (
          <div
            data-testid={TestID.Legend}
            className={styles.legend}
            style={{
              display: show ? '' : 'none',
              height:
                height <= 1000 &&
                width <= 500 &&
                height != null &&
                width != null
                  ? '40%'
                  : '40%',
              width:
                height <= 1000 &&
                width <= 500 &&
                height != null &&
                width != null
                  ? '87%'
                  : '65%',
              overflowY: 'auto',
            }}
          >
            <Row span={14}>
              <Col flex={13}>
                <h4>Legende</h4>
              </Col>
              <Col flex={1} style={{ marginTop: '-10px' }}>
                <Button
                  type="text"
                  icon={<EyeInvisibleOutlined />}
                  size="large"
                  onClick={() => {
                    setShow((v) => !v);
                  }}
                />
              </Col>
            </Row>

            <p>
              <i
                className={`${styles.I}`}
                style={{ background: colorValues[5] }}
              >
                &nbsp;
              </i>
              <span>{text[5]}</span>
            </p>
            <p>
              <i
                className={`${styles.I}`}
                style={{ background: colorValues[4] }}
              >
                &nbsp;
              </i>
              <span>{text[4]}</span>
            </p>
            <p>
              <i
                className={`${styles.I}`}
                style={{ background: colorValues[3] }}
              >
                &nbsp;
              </i>
              <span>{text[3]}</span>
            </p>
            <p>
              <i
                className={`${styles.I}`}
                style={{ background: colorValues[2] }}
              >
                &nbsp;
              </i>
              <span>{text[2]}</span>
            </p>
            <p>
              <i
                className={`${styles.I}`}
                style={{ background: colorValues[1] }}
              >
                &nbsp;
              </i>
              <span>{text[1]}</span>
            </p>
            {showMore && (
              <>
                <h4>Flächennutzung</h4>
                <p>
                  <i className={`bg-green2-color ${styles.I}`}>&nbsp;</i>
                  <span>Landwirtschaft</span>
                </p>
                <p>
                  <i className={`bg-green2-color ${styles.I}`}>&nbsp;</i>
                  <span>Sandflächen</span>
                </p>
                <p>
                  <i className={`bg-green3-color ${styles.I}`}>&nbsp;</i>
                  <span>Grün, Wiesen, Feuchtwiesen</span>
                </p>
                <p>
                  <i className={`bg-green4-color ${styles.I}`}>&nbsp;</i>
                  <span>Parkanlangen</span>
                </p>
                <p>
                  <i className={`bg-green5-color ${styles.I}`}>&nbsp;</i>
                  <span>Friedhof</span>
                </p>
                <p>
                  <i className={`bg-green6-color ${styles.I}`}>&nbsp;</i>
                  <span>Grün-Sondernkulturen</span>
                </p>
                <p>
                  <i className={`bg-green7-color ${styles.I}`}>&nbsp;</i>
                  <span>Wald</span>
                </p>
                <p>
                  <i className={`bg-blue-color ${styles.I}`}>&nbsp;</i>
                  <span>Wasser</span>
                </p>
                <p>
                  <i className={`bg-brown-color ${styles.I}`}>&nbsp;</i>
                  <span>Einzelhandel</span>
                </p>
                <p>
                  <i className={`bg-brown2-color ${styles.I}`}>&nbsp;</i>
                  <span>Gewerbe</span>
                </p>
                <p>
                  <i className={`bg-brown3-color ${styles.I}`}>&nbsp;</i>
                  <span>Industrie</span>
                </p>
                <p>
                  <i className={`bg-pink-color ${styles.I}`}>&nbsp;</i>
                  <span>Öffentlich</span>
                </p>
                <p>
                  <i className={`bg-green8-color ${styles.I}`}>&nbsp;</i>
                  <span>Landwirtschaftliche Siedlungsfläche</span>
                </p>
                <p>
                  <i className={`bg-purple-color ${styles.I}`}>&nbsp;</i>
                  <span>Garagen</span>
                </p>
                <p>
                  <i className={`bg-brown4-color ${styles.I}`}>&nbsp;</i>
                  <span>Stellplatz-Parkplatz</span>
                </p>
                <p>
                  <i className={`bg-black-color ${styles.I}`}>&nbsp;</i>
                  <span>Straßenfläche-Asphalt</span>
                </p>
                <p>
                  <i className={`bg-grey-color ${styles.I}`}>&nbsp;</i>
                  <span>Bahn</span>
                </p>
                <p>
                  <i className={`bg-blue2-color ${styles.I}`}>&nbsp;</i>
                  <span>Wasserbecken</span>
                </p>
                <p>
                  <i className={`bg-green9-color ${styles.I}`}>&nbsp;</i>
                  <span>Militär</span>
                </p>
                <p>
                  <i className={`bg-brown5-color ${styles.I}`}>&nbsp;</i>
                  <span>Abbruch</span>
                </p>
                <p>
                  <i className={`bg-brown6-color ${styles.I}`}>&nbsp;</i>
                  <span>Abbaufläche-Steinbruch</span>
                </p>
                <p>
                  <i className={`bg-brown7-color ${styles.I}`}>&nbsp;</i>
                  <span>Deponie-Ablagerungen</span>
                </p>
              </>
            )}
            <div
              className={styles.showMore}
              onClick={() => setShowMore((v) => !v)}
              onKeyDown={(e) => e.key === 'Enter' && setShowMore((v) => !v)}
              role="button"
              tabIndex={0}
            >
              {showMore ? 'Weniger' : 'Mehr'} anzeigen
            </div>
          </div>
        )}

        <div
          className={styles.button}
          onClick={() => setShow((v) => !v)}
          onKeyDown={(e) => e.key === 'Enter' && setShow((v) => !v)}
          role="button"
          tabIndex={0}
          style={{
            display: show ? 'none' : 'block',
            right:
              ISPRINTMAPALLOWED === true ? '12% !important' : '1.5% !important',
          }}
        >
          Farblegende&nbsp;
          {show ? 'verstecken' : 'anzeigen'}
        </div>
      </div>
    </>
  );
};

Legend.propTypes = {
  selectedOption: PropTypes.string,
};

Legend.defaultProps = {
  selectedOption: 'Wohnlage',
};

export default Legend;
